import React from "react";
import { DialogActions } from "@material-ui/core";
import DialogLayout from "../../../../partials/content/DialogLayout";
import SearchItemPrice from "../itemsPrice/SearchItemPrice";

function SalesItemPrice({
  openSearchItemPrice,
  setOpenSearchItemPrice,
  itemSelected,
  customerID,
  leadID,
  exchangeRate,
  setFieldValue,
  property,
  itemIndex,
}) {
  return (
    <DialogLayout
      open={openSearchItemPrice}
      title={`Search Item Price ${itemSelected.itemName}`}
      onCloseDialog={() => {
        setOpenSearchItemPrice(false);
      }}
      maxWIdth="md"
    >
      {(customerID > 0 || leadID > 0) && itemSelected.itemID > 0 ? (
        <SearchItemPrice
          customerID={customerID}
          leadID={leadID}
          itemID={itemSelected.itemID}
          varCode={itemSelected.varCode}
          onSelectItemPrice={(itemPrice) => {
            if (exchangeRate > 0) {
              itemPrice.price = (1 / exchangeRate) * itemPrice.price;
            } else {
              itemPrice.price = 0;
            }
            setFieldValue(
              `${property}[${itemIndex}].unitPrice`,
              itemPrice.price
            );
            setFieldValue(`${property}[${itemIndex}].uomID`, itemPrice.uomID);
            setFieldValue(
              `${property}[${itemIndex}].uomName`,
              itemPrice.uomName
            );
            setOpenSearchItemPrice(false);
          }}
        />
      ) : null}

      <DialogActions>
        <button
          type="button"
          className="btn btn-label-danger btn-md btn-pill btn-bold"
          onClick={() => {
            setOpenSearchItemPrice(false);
          }}
        >
          <i className="fas fa-window-close"></i>
          Close
        </button>
      </DialogActions>
    </DialogLayout>
  );
}

export default SalesItemPrice;
